var $ = require('jquery');
var msgbox = require('../common/msgbox');
var logisticsId = 'act_logistics_popbox';
var tpl = require('../tpl/logistics.tpl');
var template = require('../common/template.js');
var list = [];
var totalLogisticsLength = 0;
var tips = '';
var l_status = false;
var actid = active_cfg.base.actid;

function LogisticsList(url) {
    if (!haslogin()) {
        login();
        return;
    }
    if (l_status) {
        return;
    }
    url = url || ('http://dyactive2.vip.xunlei.com/iface/?action=logininit&actid=' + actid);
    l_status = true;
    $.jsonp(url, function(rs) {
        l_status = false;
        var result = parseInt(rs.result);
        if (result == 0) {
            list = rs.data.prizelist || [];
            var listData = [];
            for (var k = 0, len = list.length; k < len; k++) {
                if (list[k]['fafang'] == "address") {
                    listData.push(list[k]);
                }
            }
            totalLogisticsLength = listData.length;
            var html = template.build(tpl)(listData);
            if (listData.length >= 0) {
                if (!$('#' + logisticsId).length) {
                    $('body').append(html);
                } else {
                    $('#' + logisticsId).replaceWith(html).show();
                }
                msgbox.show(logisticsId);
            }
        } else if (result == -100) {
            logout();
            login();
        } else {
            msgbox(rs.msg);
        }
    }, function() {
        l_status = false;
    });
}

$(document).on("click", "#act_logistics_popbox .turn_nav a", function() {
    var $this = $(this);
    if ($this.hasClass('disable')) {
        return;
    }

    var $curGoods = $("#act_logistics_popbox").find("div.cur_logistics");
    var idx = $curGoods.attr('index');
    idx = idx && Number(idx) || 0;

    if ($this.hasClass('prev')) {
        idx--;
        $curGoods.removeClass('cur_logistics').hide().prev().addClass('cur_logistics').show();
    } else if ($this.hasClass('next')) {
        idx++;
        $curGoods.removeClass('cur_logistics').hide().next().addClass('cur_logistics').show();
    }

    if (idx <= 0) {
        $this.parent().find("a.prev").addClass('disable');
    } else {
        $this.parent().find("a.prev").removeClass('disable');
    }

    if (idx >= totalLogisticsLength - 1) {
        $this.parent().find("a.next").addClass('disable');
    } else {
        $this.parent().find("a.next").removeClass('disable');
    }
});

module.exports = LogisticsList;


//////////////////
// WEBPACK FOOTER
// ./src/tools/logistics.js
// module id = 14
// module chunks = 0